<new-canvas [isViewMode]="isViewMode" [isGlb]="isGlb"></new-canvas>
<generate-shape #generateShape *ngIf="!isViewMode"></generate-shape>
